import { GameObject, HelperFunctions } from "../../tsthree";
import { Container, Graphics, NineSlicePlane, Rectangle, Text, TextStyle, Texture } from "pixi.js";
import { GAME_FONT } from "../Constants/Constants";
import { buttonify } from "../../engine/HelperFunctions/buttonify";

export class FileEditHelpBar extends GameObject {

    private _entries: Array<{
        name: string;
        onClick?: (_selectedElementInd: number) => void;
        subcontents?: Array<{
            name: string;
            onClick?: () => void;
        }>;
    }>;
    private _currentlySelectedSubmenu: number = -1;

    private selectedBg: Graphics;
    private subEntriesContainer: Container;
    private selectedSubMenuGraphic: Graphics;
    private subEntriesTexts: Text[];
    private fileEditViewTexts: Text[];
    private subEntriesBackground: NineSlicePlane;

    private selectMenu(_ind: number): void {
        this._currentlySelectedSubmenu = _ind;
        this.subEntriesContainer.position.set(
            -4 + this.fileEditViewTexts[_ind].position.x,
            this.subEntriesContainer.position.y
        );
        this.subEntriesTexts.forEach((e) => {
            e.visible = false;
        });
        this._entries[_ind].subcontents.forEach((e, y) => {
            this.subEntriesTexts[y].text = e.name;
            this.subEntriesTexts[y].visible = true;
        });
        this.subEntriesContainer.visible = true;
        this.subEntriesBackground.height = 4 + (20 * this._entries[_ind].subcontents.length);
    }

    constructor(_entries: Array<{
        name: string;
        onClick?: (_selectedElementInd: number) => void;
        subcontents?: Array<{
            name: string;
            onClick: () => void;
        }>;
    }>) {
        super("FileEditHelpBar");

        this._entries = _entries;

        const selectedBg = this.selectedBg = new Graphics();
        selectedBg.beginFill(0x0000ff);
        selectedBg.drawRect(0, 0, 20, 20);
        selectedBg.endFill();
        selectedBg.visible = false;
        this.addChild(selectedBg);

        const texts: Text[] = [];
        let runningWidth = 0;
        let selected: number = -1;
        this.fileEditViewTexts = [];
        _entries.forEach((e, i) => {
            const fileEditViewText = new Text(e.name, new TextStyle({
                fontFamily: GAME_FONT,
                fill: 0x000000,
                fontSize: 11,
            }));
            this.fileEditViewTexts.push(fileEditViewText);
            buttonify(fileEditViewText, {
                onFire: () => {
                    if(
                        subEntriesContainer.visible &&
                        this._currentlySelectedSubmenu === i
                    )  {
                        subEntriesContainer.visible = false;
                        this._currentlySelectedSubmenu = -1;
                    } else if(_entries[i].subcontents) {
                        this.selectMenu(i);
                    } else if(_entries[i]?.onClick) {
                        _entries[i].onClick(i);
                    }
                },
                onPointerOver: () => {
                    selected = i;
                    selectedBg.position.set(
                        fileEditViewText.x - 4,
                        -4
                    );
                    selectedBg.width = fileEditViewText.width + 8;
                    selectedBg.height = 22;
                    fileEditViewText.style.fill = 0xffffff;
                    selectedBg.visible = true;
                    if(this._currentlySelectedSubmenu !== -1 && _entries[i].subcontents) {
                        this.selectMenu(i);
                    }
                },
                onPointerOut: () => {
                    selected = -1;
                    selectedBg.visible = false;
                    fileEditViewText.style.fill = 0x000000;
                }
            });
            fileEditViewText.hitArea = new Rectangle(0, 0, fileEditViewText.width, fileEditViewText.height);
            fileEditViewText.anchor.set(0, 0);
            this.addChild(fileEditViewText);
            fileEditViewText.position.set(runningWidth, 0);
            texts.push(fileEditViewText);
            runningWidth += fileEditViewText.width + 8;
        });

        const subEntriesContainer = this.subEntriesContainer = new Container();
        subEntriesContainer.visible = false;
        subEntriesContainer.position.set(-4, selectedBg.height - 2);
        this.addChild(subEntriesContainer);
        const subEntriesBackground = this.subEntriesBackground = new NineSlicePlane(
            ENGINE.getPIXIResource("button") as Texture
        );
        subEntriesBackground.width = 130;
        subEntriesBackground.height = 2 + (20 * 5);
        subEntriesContainer.addChild(subEntriesBackground);

        const selectedSubMenuGraphic = this.selectedSubMenuGraphic = new Graphics();
        selectedSubMenuGraphic.beginFill(0x0000ff);
        selectedSubMenuGraphic.drawRect(0, 0, 20, 20);
        selectedSubMenuGraphic.width = subEntriesBackground.width - 4;
        selectedSubMenuGraphic.height = 20;
        selectedSubMenuGraphic.endFill();
        selectedSubMenuGraphic.visible = false;
        selectedSubMenuGraphic.position.set(2, 2);
        subEntriesContainer.addChild(selectedSubMenuGraphic);

        const subEntriesTexts: Text[] = this.subEntriesTexts = [];
        let selectedSubMenu: number = -1;
        for(let i = 0; i < 5; i++) {
            const subEntryText = new Text("", new TextStyle({
                fontFamily: GAME_FONT,
                fill: 0x000000,
                fontSize: 11,
            }));
            subEntryText.visible = false;
            subEntryText.position.set(4, 4 + (20 * i));
            subEntriesContainer.addChild(subEntryText);
            subEntriesTexts.push(subEntryText);
            subEntryText.hitArea = new Rectangle(-2, -2, 130, 20);
            buttonify(subEntryText, {
                onFire: () => {
                    console.log("Selected submenu %i option %i", this._currentlySelectedSubmenu, i);
                    _entries[this._currentlySelectedSubmenu].subcontents?.[i].onClick();
                    this._currentlySelectedSubmenu = -1;
                    this.selectedSubMenuGraphic.visible = false;
                    subEntriesContainer.visible = false;
                },
                onPointerOver: () => {
                    selectedSubMenu = i;
                    selectedSubMenuGraphic.position.set(
                        2,
                        2 + (20 * i)
                    );
                    selectedSubMenuGraphic.visible = true;
                    subEntriesTexts.forEach((e) => {
                        e.style.fill = 0x000000;
                    });
                    subEntryText.style.fill = 0xffffff;
                },
                onPointerOut: () => {
                    selectedSubMenu = -1;
                    selectedSubMenuGraphic.visible = false;
                    subEntriesTexts.forEach((e) => {
                        e.style.fill = 0x000000;
                    });
                }
            });
        }
    }
}